module.exports = __webpack_public_path__ + "img/lyhyjjfa_banner_img.255edd9d.png";